<span *transloco="let i18n">{{ i18n(message()) }}</span>
<mat-icon class="close-button" (click)="removeNotificationEvent()">
  cancel
</mat-icon>
